import { useQuery, UseQueryResult } from '@tanstack/react-query';
import {
    EchelonHypothesis,
    GridEchelons,
} from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/EchelonsOverview/helpers/types';
import { RQAPICall } from 'store/APIClient';

export const useGetHrSimulationEchelonsHypotheses = (
    hrSimulationId: number,
): UseQueryResult<EchelonHypothesis[]> => {
    const endpoint = `human_resources/hr_simulation/${hrSimulationId}/echelon_hypotheses`;

    return useQuery({
        queryKey: ['echelon_hypotheses', hrSimulationId],
        queryFn: async () => {
            const getResponse = await RQAPICall({
                endpoint,
                method: 'GET',
            });
            return getResponse.content.data;
        },
        meta: {
            useGlobalOnError: true,
        },
    });
};

export const useGetGridEchelons = ({
    filiere = '',
    grade = '',
    shouldFetch = true,
}: {
    filiere?: string;
    grade?: string;
    shouldFetch?: boolean;
}): UseQueryResult<GridEchelons[]> => {
    const endpoint = `human_resources/hr_grade/grid_echelons`;

    // Encoder filiere et grade pour les inclure dans l'URL
    const encodedFiliere = encodeURIComponent(filiere);
    const encodedGrade = encodeURIComponent(grade);
    const url = `${endpoint}?filiere=${encodedFiliere}&grade=${encodedGrade}`;

    return useQuery({
        queryKey: ['grid_echelons', filiere, grade],
        queryFn: async () => {
            const getResponse = await RQAPICall({
                endpoint: url,
                method: 'GET',
            });
            return getResponse.content.data;
        },
        enabled: shouldFetch,
        meta: {
            useGlobalOnError: true,
        },
    });
};
